import { TABLE_HEIGHT, TABLE_MAX_WIDTH } from '@hivewatch/dark'

export const RULES_TABLE_MAX_WIDTH = TABLE_MAX_WIDTH
export const RULES_TABLE_MAX_HEIGHT = TABLE_HEIGHT
export const RULES_TABLE_HEADER_HEIGHT = 40
export const RULES_TABLE_ROW_HEIGHT = 56
export const RULES_TABLE_PAGINATION_HEIGHT = 56
export const RULES_TABLE_EMPTY_ROW_COUNT = 1
export const RULES_TABLE_PAGE_SIZE_OPTIONS = [5, 10, 25, 50]
export const RULES_TABLE_ACTION_COLUMN_WIDTH = '64px'
export const RULES_APP_HEADER_HEIGHT = '64px'
export const RULES_LEGACY_HEADER_HEIGHT = '65px'
export const RULES_TABLE_VIEW_PADDING_X = 6
export const RULES_TABLE_VIEW_PADDING_Y = 4
